import { render, staticRenderFns } from "./sistema-context.vue?vue&type=template&id=3a6abe5e"
import script from "./sistema-context.vue?vue&type=script&lang=js"
export * from "./sistema-context.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports